import React from "react";
import { BrowserRouter as Router, useLocation } from "react-router-dom";
import { isDesktop } from "react-device-detect";

import { queryStr1StParty, queryStr2NdParty } from './Constants';

//styles
import './css/Custom.css';

//ads
import LateralIzquierdo from './ads/LateralIzquierdo';
import LateralDerecho from './ads/LateralDerecho';
import Caja3 from './ads/Caja3';
import Zocalo from './ads/Zocalo';

//components
import Header from './components/common/Header';
import Home from "./components/home/Home";
import Comparing from "./components/comparing/Comparing";
import EmptySpace from "./components/common/EmptySpace";

const App = () => {

    return (
        <>
            <Header />
            <main className="container-fluid d-flex justify-content-around cont-principal px-0">
                {isDesktop && <LateralIzquierdo />}
                <section className="container mt-3 mx-1 px-0 cont-layout">
                    <Router>
                        <HandleViews />                  
                        <section className="mt-3 mt-md-0">
                            {isDesktop && <Caja3 />}
                            <EmptySpace />
                            <Zocalo isDesktop={isDesktop} />
                        </section>    
                    </Router>  
                </section>            
                {isDesktop && <LateralDerecho />}
            </main>
        </>
    );
}

export default App;

const GetQuery = () => {
    return new URLSearchParams(useLocation().search);
}

const HandleViews = () => {

    const { search } = useLocation();    
    const query = GetQuery(); 
    const slugParty1 = query.get(queryStr1StParty) as string;
    const slugParty2 = query.get(queryStr2NdParty) as string;

    return ((search.includes(slugParty1) && slugParty1 !== null) && (search.includes(slugParty2) && slugParty2 !== null))
        ? <Comparing slugParty1={slugParty1} slugParty2={slugParty2} />
        : <Home />
}